import clsx from 'classnames'
import * as React from 'react'

export type SlideDirection = 'right' | 'left'
interface SlideTransitionProps {
  transKey: React.Key
  className?: string
  slideDirection: SlideDirection
  children: React.ReactNode
}

const SlideTransition: React.FunctionComponent<SlideTransitionProps> = ({ children, transKey, className = null }) => {
  const [currentKey, setCurrentKey] = React.useState(transKey)
  const [currentChildren, setCurrentChildren] = React.useState(children)

  React.useEffect(() => {
    if (transKey !== currentKey) {
      setCurrentChildren(children)
      setCurrentKey(transKey)
    }
  }, [transKey, children, currentKey])

  return <div className={clsx('MuiPickersSlideTransition-transitionContainer', className)}>{currentChildren}</div>
}

export default SlideTransition
